import { Grid, Typography } from '@mui/material';
import React from 'react';
import CustomButton from '../../../common/ui/CustomButton';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../common/constants/Routes';
import AddIcon from '@mui/icons-material/Add';
import cryptoEncryptionDecryption from '../../../common/crypo';
import { useTranslation } from 'react-i18next';
function DonerHeader() {
  const {t}=useTranslation()
  const navigate = useNavigate();
  const handleNavigate = () => {
  
    navigate(APP_ROUTES.DASHBOARD);
  };
  const permissions= localStorage.getItem("permissions");
  const decrptedPermissions= cryptoEncryptionDecryption.Decrypt(permissions)
  const decryptedPermissions = JSON.parse(decrptedPermissions);
 
  const decryptedPermissions3 =JSON.parse(decryptedPermissions)

  return (
    <Grid
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      className='donation-header'
    >
      <Typography fontSize={20} fontWeight={700}>
       {t('Manage_Donors')}
      </Typography>
      <CustomButton
        type='button'
        text={`${t('Add_Donor')}`}
        startIcon={AddIcon}
        className=' px-10 py-5 my-20'
        fontSize={14}
        onClick={() => {
          navigate(APP_ROUTES.DONER_ADD);
        }}
        disabled={!decryptedPermissions3?.Donor?.add}
        color={'warning'}
      />
    </Grid>
  );
}

export default DonerHeader;
